module.exports = __webpack_public_path__ + "static/media/03_street_middle.88a215b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/png/street/03_street_middle.png
// module id = 424
// module chunks = 0